import { createRouter, createWebHashHistory } from 'vue-router'
import layout from '@/layout'
import store from '@/store'
import permissionAdmin from './modules/permission/permissionAdmin'

import permissionRole from './modules/permission/permissionRole'
import permissionMark from './modules/permission/permissionMark'
import AdminLog from './modules/other/adminLog'

import HsgtLgtRow from './modules/hsgt_lgt/row'
import HsgtLgtCol from './modules/hsgt_lgt/col'
import HsgtLgtOnePlus from './modules/hsgt_lgt/one_plus'
import shareholdersNum from './modules/shareholders/num.js'
import shareholdersNumTen from './modules/shareholders/num-10.js'
import shareholdersAll from './modules/shareholders/all.js'
// import shareholdersNumTenOnePlus from './modules/shareholders/num-10-one-plus.js'
import shareholdersStock from './modules/shareholders/stock.js'
import UserStock from './modules/user/user-stock/index.js'
import UserStockNote from './modules/user/user-stock-note/index.js'
import UserWinner from './modules/user/user-winner/index.js'

import WinnerFlowCalendar from './modules/winner/flow_calendar/index'
// import WinnerAttetionCalendar from './modules/winner/attention_calendar/index'
// import WinnerMuchCalendar from './modules/winner/much_calendar/index'
// import WinnerEmptyCalendar from './modules/winner/empty_calendar/index'
import WinnerDaily from './modules/winner/winner_daily/index'
import WinnerOpen from './modules/winner/winner_open/index'
import WinnerSelf from './modules/winner/winner_self/index'
import WinnerSelfMock from './modules/winner/winner_self_mock/index'
import WinnerOverview from './modules/winner/overview/index'
import WinnerCalOpen from '@/router/modules/winner/cal_open'
// import WinnerCalClose from '@/router/modules/winner/cal_close'
import FamousIndex from '@/router/modules/famous/index'
import RzrqIndex from '@/router/modules/rzrq/index'
import IndustryIndex from '@/router/modules/industry/index'
import SearchIndex from '@/router/modules/search/index'
import TotalIc from '@/router/modules/total/ic/index'
import ShareholdersWinner from '@/router/modules/shareholders_winner/index'
import DataWorkbench from '@/router/modules/data-workbench/index'

/**
 * 私有路由表 需要有权限才能访问
 */
export const privateRoutes = [
  // 量化数据工作台是独立一级菜单，不与某一个业务数据源绑定。
  DataWorkbench,
  // 名人战法 -  名人战法
  FamousIndex,
  // 行业&概念 - 总览
  TotalIc,
  // 沪深港通 - 陆股通 - 横版
  HsgtLgtRow,
  // 沪深港通 - 陆股通 - 竖版
  HsgtLgtCol,
  // 沪深港通 - 陆股通 - +1open
  HsgtLgtOnePlus,
  shareholdersAll,
  // 十大流通股东
  shareholdersStock,
  // 股东 - 十大流通股股东
  shareholdersNumTen,
  // 股东 - 股东数
  shareholdersNum,
  // 当日龙虎榜 - 龙虎榜
  WinnerDaily,
  // 龙虎榜总览 - 龙虎榜
  WinnerOverview,
  // 龙虎榜 +1 open
  WinnerOpen,
  // 龙虎榜 - 自选股
  WinnerSelf,
  // 龙虎榜 - 自选模拟
  WinnerSelfMock,
  //  龙虎榜日历 - 龙虎榜
  WinnerFlowCalendar,
  // //  关注日历 - 龙虎榜
  // WinnerAttetionCalendar,
  // //  做多日历 - 龙虎榜
  // WinnerMuchCalendar,
  // //  做空日历 - 龙虎榜
  // WinnerEmptyCalendar,
  // 量化计算（open）- 龙虎榜
  WinnerCalOpen,
  // 量化计算（close）- 龙虎榜
  // WinnerCalClose,
  // 股东 - 全部十大股东

  // 股东 - 十大股东加1
  // shareholdersNumTenOnePlus,
  // 股东 - 量化计算
  // 搜索 - 探索1
  SearchIndex,
  // 融资融券 - 融资融券
  RzrqIndex,
  // 新增独立的“行业”一级菜单，与融资融券平级；申万三作为其子页面。
  IndustryIndex,

  ShareholdersWinner,

  // 陆股通 - 我的自选股
  UserStockNote,
  UserStock,
  // 龙虎榜 - 我的自选股,
  UserWinner,
  // 管理员列表
  permissionAdmin,
  // 角色管理
  permissionRole,
  // 权限管理
  permissionMark,
  // 日志
  AdminLog
]
/**
 * 公开路由表 不需要登录 就能访问的页面
 */
export const publicRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index')
  },
  {
    path: '/bindWx',
    component: () => import('@/views/login/bindwx')
  },
  {
    path: '/',
    // 注意：带有路径“/”的记录中的组件“默认”是一个不返回 Promise 的函数
    component: layout,
    redirect: '/index',
    children: [
      // 个人中心
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          title: 'profile',
          icon: 'home'
        }
      },
      // 404 页面
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/error_page/404')
      },
      // 401 页面
      {
        path: '/401',
        name: '401',
        component: () => import('@/views/error_page/401')
      }

    ]
  }

]

export function resetRouter () {
  if (store.getters.adminInfo && store.getters.adminInfo.permission && store.getters.adminInfo.permission.menus) {
    const menus = store.getters.adminInfo.permission.menus

    menus.forEach(menu => {
      router.removeRoute(menu)
    })
  }
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: publicRoutes
})

export default router
